import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Eyebrow } from "@/components/landing/Eyebrow";
import { FAQS, SCROLL_REVEAL } from "@/lib/content";

export const FAQ = () => {
  const visible = FAQS.slice(0, 5);
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-ink-soft py-12 sm:py-16"
    >
      <div className="absolute top-0 left-0 right-0 hairline-h" aria-hidden />
      <div className="container px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto">
        <motion.div {...SCROLL_REVEAL} className="text-center">
          <div className="flex justify-center">
            <Eyebrow label="FAQ" sub={`${visible.length}`} />
          </div>
          <h2 className="font-serif-tc mt-4 sm:mt-5 text-[22px] leading-[1.2] sm:text-3xl lg:text-4xl font-bold tracking-[-0.02em]">
            常見疑問
          </h2>
        </motion.div>

        <motion.div {...SCROLL_REVEAL} className="mt-6 sm:mt-8 card-dark px-5 sm:px-7 py-1">
          <Accordion type="single" collapsible defaultValue="item-0" className="w-full">
            {visible.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[rgba(255,255,255,0.06)] last:border-b-0">
                <AccordionTrigger
                  data-testid={`faq-item-${i}-trigger`}
                  className="font-serif-tc text-left text-[14px] sm:text-[15px] font-semibold text-[hsl(var(--foreground))] hover:no-underline py-3.5 sm:py-4"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[13px] sm:text-[14px] leading-relaxed text-[hsl(var(--muted-foreground))] pb-4">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
